import axios from "./../../axiosMiddleware/index";
import { api } from "../../apiendpoints/index";
export const LogoutApi = () => {
  return axios.post(`${api.LOGIN.LOGOUT}`);
};
